module.exports = __webpack_public_path__ + "img/charge.02329b56.svg";